import { $modal } from './../../angular_imports';
import { isNullOrUndefined } from 'app/shared/utils';

// HACK singleton state
// TODO turn into a mockable service.
let globalModal = null;

export interface NWayConfirmationMode {
    name: string;
    promiseValue: string;
    buttonText: string;
    isCancel: boolean;
    isEscape: boolean;
    displayButton: boolean;
    callback: () => any;
    styleObj: any;
    classList: Array<string>;
}

export function getNWayConfirmationMode(
    name: string, // identifier, also method placed on component for testing
    promiseValue: string, // value returned in the promise
    buttonText: string, // text displayed on the button
    isCancel: boolean = false, // affects the styling
    isEscape: boolean = undefined, // fire the callback when the modal is escaped
    displayButton: boolean = true, // should display the button or not
    callback: () => any = undefined, // optional callback to fire when this mode is chosen,,
    styleObj: any = undefined,
    classList: Array<string> = undefined,
): NWayConfirmationMode {
    return {
        name,
        promiseValue,
        buttonText,
        isCancel,
        isEscape: isNullOrUndefined(isEscape) ? isCancel : isEscape,
        callback,
        displayButton,
        styleObj,
        classList,
    };
}

/**
 * @ngdoc service
 * @name ims.shared.service:NWayConfirmationModal
 * @description
 */

export class NWayConfirmationModal {
    callbackRun;
    modal;

    constructor(message: string, modes: NWayConfirmationMode[], alternativeStyle = false) {
        this.callbackRun = false;

        const handle = (mode: NWayConfirmationMode) => {
            globalModal = null;
            if (typeof mode.callback === 'function') {
                mode.callback();
            }
            this.callbackRun = true;
            this.modal.hide();
        };

        const ctrl = () => {
            const args = {
                header: '',
                message,
                modes,
                alternativeStyle,
                handle: (mode: NWayConfirmationMode) => {
                    handle(mode);
                },
                // This is used to simulate hitting the esc key for testing purposes
                esc: () => {
                    onHideCallbacks();
                    this.modal.hide();
                },
            };

            // make methods w/ the names of the modes available- this is used in unit testing
            for (const mode of modes) {
                args[mode.name] = () => {
                    handle(mode);
                };
            }

            return args;
        };

        const onHideCallbacks = () => {
            // The modal is dying, but it hasn't run a callback yet
            if (!this.callbackRun) {
                globalModal = null;

                for (const mode of modes) {
                    if (!(mode.isCancel || mode.isEscape)) {
                        continue;
                    }

                    // if we specified things to run on cancel / escape- run them
                    if (typeof mode.callback === 'function') {
                        mode.callback();
                    }
                }
            }
        };

        // If we have a modal
        if (globalModal) {
            // Call our cancel callbacks
            onHideCallbacks();
            // Don't open a modal
            return;
        }
        globalModal = this;

        this.modal = $modal({
            template: require('./template.html'),
            contentTemplate: 'n_way_confirmation_modal_content.html',
            html: true,
            container: 'body',
            placement: 'placement-styling',
            controller: ctrl,
            controllerAs: '$ctrl',
            show: true,
            onHide: (modal) => {
                onHideCallbacks();
                modal.$promise.then(modal.destroy);
            },
        });
    }
}
